import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    default: 'light',
    themes: {
      light: {
        primary: '#2c3e50',
        rating_A: '#0a0',
        rating_B: '#b0d513',
        rating_C: '#eabe06',
        rating_D: '#ed7d20',
        rating_E: '#d4333f',
        rating_N: '#535353'
      }
    }
  }
})
